import { ReactElement } from 'react';
import {
    CompanyInfoLayoutType,
    TCompositionLayoutType,
    TQuestion
} from '~/types/builder.types';
import { IImage, TBlockType, TLayoutType } from '~/types/model.types';
import {
    IContainerBlockStyles,
    IImageBlockStyles,
    ISocialBlockStyles,
    ISpacerBlockStyles
} from '~/types/block-styles.types';

export interface ICompositionLayoutStruct {
    type: TBlockType;
    company_info_layout_type?: CompanyInfoLayoutType;
    linked_to_company_settings?: boolean;
    layout_type?: TLayoutType;
    size?: number;
    question?: TQuestion;
    text_style?: {
        type?:
            | 'short_title'
            | 'title'
            | 'description'
            | 'two_rows_description'
            | 'regular';
        alignment?: 'center' | 'right';
        color?: string;
    };
    text_content?: string;
    image?: Partial<IImage>;
    image_styles?: Partial<IImageBlockStyles>;
    background_image?: Partial<IImage>;
    spacer_styles?: Partial<ISpacerBlockStyles>;
    social_styles?: Partial<ISocialBlockStyles>;
    container_styles?: Partial<IContainerBlockStyles>;
    children?: ICompositionLayoutStruct[];
}

export interface ICompositionLayoutTypeConfig {
    order?: number;
    icon: ReactElement;
    smallIcon: ReactElement;
    type: TCompositionLayoutType;
    title: string;
    layoutStruct: ICompositionLayoutStruct;
    category?: CompositionCategory;
    disabled?: boolean;
    disabledTooltipText?: string;
}

export enum CompositionCategory {
    Basic = 'basic',
    Popular = 'popular'
}
